"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireWildcard(require("prop-types"));
var _constant = require("../Theme/constant");
var _constant2 = require("./constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var banner = (0, _propTypes.shape)({
  type: _propTypes.default.string,
  text: _propTypes.default.string
});
var button = {
  icon: _propTypes.default.string,
  key: _propTypes.default.string,
  textColor: _propTypes.default.string,
  bgColor: _propTypes.default.string,
  borderColor: _propTypes.default.string
};
var events = {
  event: _propTypes.default.string,
  status: _propTypes.default.string,
  dateTimeUtc: _propTypes.default.string,
  dateTime: _propTypes.default.object
};
var refund = {
  key: _propTypes.default.string,
  status: _propTypes.default.string,
  messageKey: _propTypes.default.string,
  events: (0, _propTypes.objectOf)(events)
};
var checkin = {
  status: _propTypes.default.string,
  checkedInPassengers: _propTypes.default.number,
  totalPassengers: _propTypes.default.number,
  messageKey: _propTypes.default.string
};
var TemplateString = (0, _propTypes.objectOf)(_propTypes.default.string);
var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    translation: _propTypes.default.shape({
      bookingConfirmed: _propTypes.default.string,
      referenceNumber: _propTypes.default.string,
      applicationSuccessful: _propTypes.default.string,
      refundMessage: _propTypes.default.string,
      bookingProcessing: _propTypes.default.string,
      manageBooking: _propTypes.default.string,
      downloadItienairy: _propTypes.default.string,
      payNow: _propTypes.default.string,
      paymentPending: _propTypes.default.string,
      bookingNumber: _propTypes.default.string,
      viewEboardingPass: _propTypes.default.string,
      checkIn: _propTypes.default.string
    }).isRequired,
    state: _propTypes.default.string.isRequired,
    data: _propTypes.default.shape({
      bookingStatus: _propTypes.default.string,
      bookingState: _propTypes.default.string,
      bookingText: _propTypes.default.string,
      bookingId: _propTypes.default.string,
      banners: (0, _propTypes.arrayOf)(_propTypes.default.shape(banner)),
      buttons: (0, _propTypes.arrayOf)(_propTypes.default.shape(button)),
      refund: _propTypes.default.shape(refund),
      checkin: _propTypes.default.shape(checkin)
    }).isRequired,
    isMobile: _propTypes.default.bool,
    handleBookingCallback: _propTypes.default.func,
    templateString: TemplateString,
    isToggleEnabled: _propTypes.default.bool,
    defaultToggle: _propTypes.default.bool,
    isloading: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    translation: _constant2.TRANSLATION,
    data: {},
    state: '',
    isMobile: false,
    handleBookingCallback: null,
    templateString: {},
    isloading: false,
    defaultToggle: true
  }
};
exports.default = _default;